import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import { httpGetExperience } from '../http/experience-shell.http'

export const useGetExperience = (experienceId: number) =>
	useQuery({
		queryKey: [QUERY_KEYS.EXPERIENCE, experienceId],
		queryFn: () =>
			httpGetExperience({
				urlParams: { experienceId },
				params: { responseType: 'extended' }
			})
	})
